
import EditBase from "./EditBase"

class EditPolygon extends EditBase {

    constructor(options) {
        super(options);
    }

    initProperty() {
        var $this = this;
        var hierarchyProperty = new $this.Cesium.CallbackProperty(function () {
            return new $this.Cesium.PolygonHierarchy($this.plot.attrPlot[EditBase.ext_positions]);
        }, false);
        this.plot.polygon.hierarchy = hierarchyProperty;
    }

    // mouseMove(evt) {
    //     var $this = this;
    //     //关键点
    //     if (this.pick) {
    //         var cartesian = this.getCatesian3FromPX(evt.endPosition);
    //         var i = this.pick.attrPlot.e_index;
    //         $this.plot.attrPlot[EditBase.ext_positions].splice(i, 1, cartesian);
    //         this.pick.position.setValue(cartesian);
    //         this.updateCenter();
    //         //this.updateRotate();
    //     }

    //     //中心点
    //     if (this.center) {
    //         var cartesian = this.getCatesian3FromPX(evt.endPosition);
    //         this.center.position.setValue(cartesian);
    //         this.translateAll(cartesian);
    //         //this.updateRotate();
    //     }
    // }

    // leftClick(evt) {
    //     this.hideEdit();
    //     let pick = this.viewer.scene.pick(evt.position);
    //     var entity = this.getPickEnity(pick);
    //     if (entity && entity.attrPlot && entity.attrPlot[EditBase.ext_id] == this.editGuid) {
    //         this.showEdit();
    //     }
    // }
    // leftDown(evt) {
    //     this.pick = undefined;
    //     this.center = undefined;//中心点
        
    //     let pick = this.viewer.scene.pick(evt.position);
    //     var entity = this.getPickEnity(pick);
    //     if (entity && entity.attrPlot && entity.attrPlot[EditBase.ext_keyFlag] && entity.attrPlot[EditBase.ext_id] == this.editGuid) {
    //         this.pick = entity;
    //         this.viewer.scene.screenSpaceCameraController.enableRotate = false;//锁定相机
    //     }

    //     if (entity && this.plot  && this.plot.attrPlot && entity == this.plot.attrPlot[EditBase.ext_centerPos]) {
    //         this.center = entity;
    //         this.viewer.scene.screenSpaceCameraController.enableRotate = false;//锁定相机
    //     }
    // }

    // leftUp(evt) {
    //     this.pick = undefined;
    //     this.center = undefined;//中心点
    //     this.positionMove = undefined;
    //     this.viewer.scene.screenSpaceCameraController.enableRotate = true;//解锁相机
    // }

}


export default EditPolygon
